const C = {
  name: "SouthKorea",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 3C7.02772 3 3 7.02772 3 12C3 16.9723 7.02772 21 12 21C16.9723 21 21 16.9723 21 12C21 7.02772 16.9723 3 12 3ZM5 12C5 8.13228 8.13228 5 12 5C13.9579 5 15.7274 5.80268 16.9975 7.09712C16.6783 7.03341 16.3481 7 16.0098 7C13.2442 7 11.0298 9.23099 11.0298 11.99V12.01C11.0298 13.6677 9.69752 15 8.0398 15C6.38372 15 5.0498 13.6593 5.0498 12.01H5.00001C5 12.0067 5 12.0033 5 12ZM6.98949 16.8895C7.32795 16.9619 7.6793 17 8.0398 17C10.8021 17 13.0298 14.7723 13.0298 12.01V11.99C13.0298 10.329 14.3554 9 16.0098 9C17.6675 9 19 10.3323 19 11.99C19 11.9933 19 11.9967 19 12C19 15.8677 15.8677 19 12 19C10.0354 19 8.26047 18.1918 6.98949 16.8895Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as SouthKorea
};
